module.exports = __webpack_public_path__ + "static/img/jc-4.cc61c62a.webp";